module.exports = __webpack_public_path__ + "img/progress_005.f6bc8721.png";